import { Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const KIDS_PROFILE_FILTER_SERVICE: InjectionToken<string> = new InjectionToken<string>('KIDS_PROFILE_FILTER_SERVICE');

@Injectable()
export abstract class KidsProfileFilterAbstractService {
  public abstract hasValidProfileState$: Observable<boolean>;
  public abstract isKidsProfileType$: Observable<boolean>;
}
